import { t } from '../utils/i18n'

const ToggleableComponent = ({ name, componentToggle }) => {
  return (
    <div>
      <div
        onClick={componentToggle}
        className="velorbis-grouped-component__head velorbis-toggle-component"
      >
        <span>{t(name)}</span>
      </div>
    </div>
  )
}

export default ToggleableComponent
